import React, { FC, useCallback } from 'react';
import { TimelineItemProps } from '@v2/pages/machines/common/types/props';
import { scale } from '@components/frame';
import { Text, View } from 'react-native';
import { font } from '@styles/fonts';
import i18n from 'i18n-js';
import ItemTime from '@components/machines/components/detailsComponents/activeMachine/components/TimeLine';
import { machineStatus } from '@helpers';
import { NotProductiveBlock } from '@v2/pages/machines/modules/timeline/components/NotProductiveBlock/NotProductiveBlock';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { setSelectedMachineRunningTime } from '@reducers/machinesV2';
import TimeDisplayInStaticFormat from '@components/common/TimeDisplayInStaticFormat';

interface Props extends TimelineItemProps {}

const TimelineItem: FC<Props> = ({ loading, selected, item, timeOffset, C }) => {
  const dispatch = useAppDispatch();

  const handleRunningTimeUpdate = useCallback(
    (time: number) => {
      dispatch(setSelectedMachineRunningTime(time));
    },
    [dispatch]
  );
  if (loading) {
    return (
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          marginTop: scale(1),
        }}
      >
        <View style={{ width: scale(10), height: scale(12) }} />
        <View style={{ marginLeft: scale(5.5), flex: 1 }}>
          <Text style={[font['Subhead 2'], { color: C(selected ? 'Label/Light/AlwaysLight Secondary' : 'Label/Light/Tertiary') }]}>
            {i18n.t('Connecting')}...
          </Text>
        </View>
      </View>
    );
  }

  return item.machineStatus.status !== machineStatus.NOTPRODUCTIVE ? (
    <View
      style={{
        marginTop: scale(9),
        marginLeft: scale(15.5),
        flex: 1,
        paddingRight: scale(10),
        opacity: item.isProcessingPI ? 0 : 1,
      }}
    >
      <ItemTime
        timeOffset={timeOffset}
        C={C}
        machineStatus={item.machineStatus}
        hideNCFile
        hideDurationTime
        selected={selected}
        setActualTimeForLatestEvent={selected ? handleRunningTimeUpdate : undefined}
        getTimeDisplayComponent={(timeValue) => (
          <TimeDisplayInStaticFormat
            timeValue={timeValue}
            C={C}
            fontForDigit="Time 3"
            fontForDelimiter="Caption 1"
            fontForSecondDigit="Time 4"
            color={selected ? 'Label/Light/AlwaysLight Secondary' : 'Label/Light/Tertiary'}
            delimiterAlignCenter={false}
          />
        )}
      />
    </View>
  ) : (
    <NotProductiveBlock
      ncFileStatus={item.machineStatus.ncFileStatus}
      ncFile={item.machineStatus.ncFile}
      subStatus={item.machineStatus.subStatus}
      status={item.machineStatus.status}
      lastModified={item.machineStatus.lastUpdatedOn}
      C={C}
      selected={selected}
      timeOffset={timeOffset}
    />
  );
};

export { TimelineItem };
